module.exports = __webpack_public_path__ + "static/media/referencia-recorte.e6500bdb.svg";